export default __webpack_public_path__ + "static/media/trendingArrow.58154811.svg";